import styled from "styled-components";

export const UserLevelContainer = styled.div`
  width: fit-content;

  img {
    filter: drop-shadow(0px 0px 16px #000000);
  }
`;
